import { IntlShape, useIntl } from "react-intl";
import { ExpandedFormats } from "@sinch/core/hooks/format.types";

export const useFormatList = () => {
  const { formatList: listFormatter, formats } = useIntl() as IntlShape & {
    formats: ExpandedFormats;
  };
  return (value: string[] | readonly string[], { format }: { format?: string | keyof ExpandedFormats["list"] }) => {
    const options = format ? formats.list[format as keyof ExpandedFormats["list"]] : {};

    return listFormatter(value, { ...options });
  };
};
